/**
 *
 * Product Carousel with Filters
 *
 */

export default function obBlogCarousel() {
    // initialize carousel
    const $container = $('.ob-blog-feed');
    const $carousel = $container.find('.blogGrid');

    initializeCarousel($carousel);

    function initializeCarousel($carousel) {
        const $progressBar = $carousel.next('.ob-slider-progress');
        const $progressBarLabel = $progressBar.find('.slider__label');

        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        $carousel.on('init', function(event, slick) {  
            let calc = (1 / (slick.slideCount)) * 100;
            
            $progressBar
              .css('background-size', calc + '% 100%')
              .attr('aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
        });

        // Initialize Slick
        $carousel.slick({
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "arrows": false,
            "dots": false,
            "infinite": true,
            "mobileFirst": true,
            "swipeToSlide": true,
            "responsive": [
                {
                    "breakpoint": 767,
                    "settings": {
                        "slidesToShow": 2
                    }
                },
                {
                    "breakpoint": 1023,
                    "settings": {
                        "slidesToShow": 3,
                        "arrows": true
                    }
                }
            ]
        });

        let sliderLength = $carousel.length - 1;

        $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {  
            let calc;

            if(nextSlide === sliderLength) {
                calc = 100;
            } else {
                calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
            }

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
            $progressBarLabel.text( calc + '% completed' );
        });
    }
}
